import axios from "axios";

export const BASE_URL =
  process.env.VUE_APP_SERVER_URI || "http://localhost:3000";

const apiClient = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

class ApiService {
  // Метод для GET-запросов
  static async get(endpoint, params = {}) {
    try {
      const response = await apiClient.get(endpoint, { params });
      return response;
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Метод для POST-запросов
  static async post(endpoint, data) {
    try {
      const response = await apiClient.post(endpoint, data);
      return response;
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Метод для PUT-запросов
  static async put(endpoint, data) {
    try {
      const response = await apiClient.put(endpoint, data);
      return response;
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Метод для PATCH-запросов
  static async patch(endpoint, data) {
    try {
      const response = await apiClient.patch(endpoint, data);
      return response;
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Метод для DELETE-запросов
  static async delete(endpoint, config = {}) {
    try {
      const response = await apiClient.delete(endpoint, config);
      return response;
    } catch (error) {
      return this.handleError(error);
    }
  }

  // Обработка ошибок
  static handleError(error) {
    if (error.response) {
      return {
        success: false,
        status: error.response.status,
        data: error.response.data,
      };
    }

    return {
      success: false,
      message: error.message,
    };
  }
}

export default ApiService;
